import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'reactstrap';

import useTranslate from '../../hooks/useTranslate';

const SummerSaleBanner: FC = () => {
  const { translate, activeLanguage } = useTranslate();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${activeLanguage?.code}/summer-sale-2025`);
  };

  return (
    <Alert
      color="none"
      className="text-center mb-0 text-white rounded-0 fw-bold"
      style={{
        backgroundColor: '#7ca324',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      {String(translate('campaign-summer-sale.promo'))}
    </Alert>
  );
};

export default SummerSaleBanner;
